export const getSessionStorageInteger = (key: string): number => {
    const sessionStorageValue = sessionStorage.getItem(key);

    if (!sessionStorageValue) {
        return 0;
    }

    const value = Number(sessionStorageValue);

    return isNaN(value) ? 0 : Math.ceil(value);
};

export const setSessionStorageInteger = (key: string, value: number): void => {
    return sessionStorage.setItem(key, Math.ceil(value).toString());
};

export const resetSessionStorageInteger = (key: string): void => {
    return sessionStorage.removeItem(key);
};
